import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/reducers";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import { Observable } from "rxjs";
import { AppSessionService } from "../../app-session/app-session.service";
import {
  setAdvancedFilterQuery,
  setSimpleFilterQuery,
} from "src/app/shared/utils/tableUtils";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class ProductGroupService {
  private BASE_URL = this.appSession.baseUrl + "/api/v1/products/groups";

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private appSession: AppSessionService
  ) {}

  getProductGroup(pageReq: PaginationRequest): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set(
      "Content-type",
      "application/x-www-form-urlencoded; "
    );

    if (pageReq && pageReq.query && (pageReq.query as string).length > 0) {
      headers = headers.set("query", pageReq.query);
    }

    let url = `${this.appSession.baseUrl + "/api/v1/products/groups"}`;

    if (!pageReq) {
      // pageReq not defined
      pageReq = {
        offset: 0,
        limit: undefined,
        realSize: true,
      };
    }
    const sort = "";

    const pagination =
      "?offset=" +
      pageReq.offset +
      (pageReq.limit ? "&limit=" + pageReq.limit : "") +
      "&real_size=" +
      pageReq.realSize;
    url = url.concat(pagination);

    return this.http.get(url, { headers });
  }
  // get contract
  getProductGroupByCode(code): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    const url = `${this.appSession.baseUrl + `${this.BASE_URL}`}/${code}`;
    return this.http.get(url, { headers });
  }

  createProductGroup(productGroup): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(productGroup);
    const url = `${this.appSession.baseUrl}${this.BASE_URL}`;
    return this.http.post(url, data, { headers });
  }
  
  updateProductGroup(productGroup): Observable<any> {
    const headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const data = JSON.stringify(productGroup);
    const url = `${this.appSession.baseUrl}${this.BASE_URL}/${productGroup?.token}`;
    return this.http.put(url, data, { headers });
  }

  public getProductGroupList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (filteringArgs) {
      filterQuery = setSimpleFilterQuery(filteringArgs);
    }

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.get(
      this.buildDataUrl(
        paging,
        filteringArgs,
        sortingArgs,
        headers,
        "/search?"
      ),
      { headers }
    );
  }

  // Grid filter helpers block
  private buildDataUrl(
    pagingArgs: any,
    filteringArgs: any,
    sortingArgs: any,
    header: HttpHeaders,
    path: string
  ): string {
    // let baseQueryString = `${DATA_URL}?$count=true`;
    let baseQueryString = `${
      this.appSession.baseUrl + "/api/v1/products/groups"
    }${path}`; // `${this.BASE_URL}/customers/search?`;
    let scrollingQuery = EMPTY_STRING;
    let query = EMPTY_STRING;

    if (pagingArgs) {
      scrollingQuery = this._buildScrollExpression(pagingArgs);
    }
    query +=
      scrollingQuery !== EMPTY_STRING ? `&${scrollingQuery}` : EMPTY_STRING;

    baseQueryString += query;

    return baseQueryString;
  }

  private _buildScrollExpression(pagingArgs): string {
    const skip = pagingArgs.skip;
    const top = pagingArgs.top;
    const realSize = pagingArgs.realSize;

    if (top && top !== null) {
      return `real_size=${!!realSize}&offset=${skip}&limit=${top}`;
    } else {
      return `real_size=${!!realSize}&offset=${skip}`;
    }
  }
}
